<style scoped>
.bg-primary {
  background-color: #1a3665 !important;
}
.file {
  visibility: hidden;
  position: absolute;
}
.browse {
  background-color: #1a3665 !important;
  color: white;
}
.custom-file-input ~ .custom-file-label[data-browse]::after {
  background-color: #1a3665 !important;
  color: white !important;
  word-wrap: break-word !important;
  white-space: normal !important;
}
</style>
<template>
  <CCard>
    <CCardHeader
      style="background: #1a3665; color: white"
      class="d-flex align-items-center font-weight-bold"
    >
      Master Informasi Umum
      <template v-if="role_status && role_status.status_create">
      <CButton
        color="info"
        style="float: right"
        class="btn-md ml-auto button-md-block px-3"
        @click="createData"
        >Tambah
      </CButton>
      </template>
      <template v-else>
      <CButton
        color="secondary"
        style="float: right"
        class="btn-md ml-auto button-md-block px-3"
        >Tambah
      </CButton>
      </template>
    </CCardHeader>
    <CCardBody>
      <CRow>
        <CCol xl="12">
          <CSelect
            label="Data Perhalaman"
            class="float-left"
            @change="changePageSize"
            :options="[10, 25, 100, 'Semua Data']"
          />
          <CInput
            label="Pencarian"
            class="float-right"
            placeholder="Cari Data .."
            v-model="search"
          />
          <br />
        </CCol>

        <CCol lg="12" class="table-responsive">
          <CDataTable
            style="widht: 100% !important"
            :items="items"
            :fields="fields"
            :noItemsView='{  noItems: noItems  }'
            hover
            sorter
          >
            <template #no="{ index }">
              <td class="py-2">{{ index + 1 }}</td>
            </template>
            <template #judul="{ item }">
              <td class="py-2">{{ item.judul }}</td>
            </template>
            <template #deskripsi="{ item }">
              <td class="py-2">{{ item.deskripsi.substr(0, 60) + "..." }}</td>
            </template>

            <template #file="{ item, index }">
              <td class="py-2 text-center text-info" style="cursor: pointer">
                <template v-if="role_status && role_status.status_read">
                <button
                  :class="item.file === null ? 'btn btn-secondary' : 'btn btn-success'"
                  :disabled="item.file === null"
                  @click="lihatFile(item.file, index)"
                >
                  Lihat File
                </button>
                </template>
                <template v-else>
                <button
                  class="btn btn-secondary"
                  disabled
                >
                  Lihat File
                </button>
                </template>
              </td>
            </template>

            <template #aksi="{ item, index }">
              <td class="py-2 text-center">
                <template v-if="role_status && role_status.status_update">
                  <CButton
                    color="info"
                    square
                    class="btn-sm"
                    @click="updateData(item, index)"
                  >
                    <font-awesome-icon icon="edit" /> </CButton
                  >&nbsp;&nbsp;
                </template>
                <template v-else>
                  <CButton
                    color="secondary"
                    square
                    class="btn-sm"
                    disabled
                  >
                    <font-awesome-icon icon="edit" /> </CButton
                  >&nbsp;&nbsp;
                </template>
                <template v-if="role_status && role_status.status_delete">
                  <CButton
                    square
                    color="danger"
                    class="btn-sm"
                    @click="deleteData(item, index)"
                  >
                    <font-awesome-icon icon="trash" />
                  </CButton>
                </template>
                <template v-else>
                  <CButton
                    square
                    color="secondart"
                    class="btn-sm"
                    disabled
                  >
                    <font-awesome-icon icon="trash" />
                  </CButton>
                </template>
              </td>
            </template>
          </CDataTable>

          <CPagination
            style="float: right"
            :active-page.sync="currentPage"
            :pages="pagination.totalPages"
            responsive
            @click="pageChange"
          />
        </CCol>
      </CRow>
      <CModal
        title="Modal title"
        :show.sync="myModal"
        :no-close-on-backdrop="true"
        :centered="true"
      >
        <CForm v-on:submit.prevent="postData">
          <CRow>
            <CCol sm="12">
              <label for="judul" class="font-weight-bold">Judul</label>
              <input
                type="text"
                class="form-control"
                :class="{
                  'is-invalid': $v.formData.judul.$error,
                }"
                id="judulInput"
                placeholder="Masukkan Judul..."
                v-model="formData.judul"
                aria-required="true"
                @input="setJudul($event.target.value)"
              />
            </CCol>
            <CCol sm="12">
              <label for="deskripsi" class="font-weight-bold">Deskripsi</label>
              <textarea
                class="form-control"
                :class="{
                  'is-invalid': $v.formData.deskripsi.$error,
                }"
                id="deskripsiInput"
                placeholder="Masukkan Deskripsi..."
                v-model="formData.deskripsi"
                @input="setDeskripsi($event.target.value)"
                rows="5"
              />
            </CCol>

            <CCol sm="12 mb-5">
              <label for="uid-zwqayuopq3" class="font-weight-bold">
                Unggah File
              </label>
              <br />
              <div class="custom-file text-truncate">
                <input
                  type="file"
                  class="custom-file-input"
                  id="customFileLangHTML"
                  ref="uploadFileInformasiUmum"
                  :required="actionPost == 'update'"
                  @change="fileUpload"
                />
                <label
                  class="custom-file-label text-truncate"
                  for="customFileLangHTML"
                  data-browse="Unggah"
                  >{{
                    typeof formData.file === "string" ? formData.file : fileName
                  }}</label
                >
              </div>
              <small class="text-danger"
                >(*File harus bertipe PDF max. 10MB)</small
              >
            </CCol>
          </CRow>
        </CForm>

        <template #header>
          <h6 class="modal-title h4 font-weight-bold">Tambah</h6>
        </template>

        <template #footer class="mt-5">
          <CButton @click="closeModal" color="danger">Tutup</CButton>
          <CButton @click="postData" type="submit" color="success"
            >Simpan</CButton
          >
        </template>
      </CModal>
    </CCardBody>
  </CCard>
</template>
<script>
import axios from "axios";
import { required } from "vuelidate/lib/validators";

import InformasiService from "@/services/datamaster/informasi-umum.service";
import BaseUrl from "@/services/base-url";
import { AlertUtils } from "@/mixins/AlertUtils";
import { exportUtils } from "@/mixins/exportUtils";

const fields = [
  { key: "no" },
  { key: "judul", _style: "text-align: left" },
  { key: "deskripsi", _style: "width:40%; text-align: left" },
  { key: "file", _style: "width:20%; text-align: center" },
  { key: "aksi", _style: "width:16%; text-align: center" },
];

export default {
  name: "InformasiUmum",
  mixins: [AlertUtils, exportUtils],
  data() {
    return {
      search: "",
      noItems : "No items",
      pageSize: 10,
      indexed: "",
      currentPage: 0,
      title: "",
      formData: {
        no: "",
        judul: "",
        deskripsi: "",
        file: "",
        statusUpdateFile: "",
        status: "",
      },
      fileName: "Pilih File",
      fields,
      details: [],
      no: 1,
      actionPost: "",
      items: [],
      pagination: {
        totalPages: 0,
      },
      status: false,
      myModal: false,
      horizontal: { label: "col-3", input: "col-9" },
      collapseDuration: 0,
      content: [],
      baseUrl: "",
      awaitingSearch: false,
      role_status: null
    };
  },

  validations: {
    formData: {
      judul: { required },
      deskripsi: { required },
    },
  },

  mounted() {
    // this.$store.dispatch("request/getInformasiUmum");
    this.baseUrl = BaseUrl();
    this.roleData();
    $(document).on("click", ".browse", function () {
      var file = $(this).parent().parent().parent().find(".file");
      file.trigger("click");
    });
    $(document).on("change", ".file", function () {
      $(this)
        .parent()
        .find(".form-control")
        .val(
          $(this)
            .val()
            .replace(/C:\\fakepath\\/i, "")
        );
    });
  },
  watch: {
    search: function (val) {
      clearTimeout(this.timeout);
      var vm = this;
      this.timeout = setTimeout(function () {
        // enter this block of code after 1 second
        // handle stuff, call search API etc.
        vm.getData("0", vm.pageSize, vm.search);
      }, 1000);
    },
    currentPage: function (val) {
      //alert val -1
      var page = val - 1;
      this.indexed = page * 10;
      this.getData(val - 1, this.pageSize, this.search);
    },
    myModal: function () {
      this.clearValidation();
    },
  },
  methods: {
    getStatusCRUDE(roleName,statusName) {
      var user = JSON.parse(localStorage.getItem('user'));
      if(user.singleData == {}) {
        return false;
      }

      if(user.singleData.detail_user.roles == null) {
        return false
      }  
      var data = user.singleData.detail_user.roles.find(el => el.nama_role === roleName );
      if(data == undefined || data == 'undefined') {
        return false;
      } else {
        if(roleName == 'ROLE_LOG') {
          if(data.status_read == true) {
            return true
          } else {
            return false
          }
        } else {
          switch (statusName) {
            case "status_create":
              return data.status_create;
              break;
            case "status_read":
              return data.status_read;
              break;

            case "status_update":
              return data.status_update;
              break;
            case "status_delete":
              return data.status_delete;
              break;

            case "status_export":
              return data.status_export;
              break;
          
            default:
              return data.status_create;
              break;
          }
        }
      }
    },
    setJudul(value) {
      this.formData.judul = value;
      this.$v.formData.judul.$touch();
      if (!this.$v.formData.judul.$error) {
        document.getElementById("judulInput").classList.add("is-valid");
      }
    },
    setDeskripsi(value) {
      this.formData.deskripsi = value;
      this.$v.formData.deskripsi.$touch();
      if (!this.$v.formData.deskripsi.$error) {
        document.getElementById("deskripsiInput").classList.add("is-valid");
      }
    },

    lihatFile(item, index) {
      if (item != "" && item != null) {
        let routeData = this.baseUrl + "/files?filename="+item+"&path=datamaster@informasiumum"; 
        window.open(routeData, "_blank");
        return false;
      } 
      else {
        this.$swal.fire({
          title: "Informasi",
          text: "File Tidak Ditemukan.",
          icon: "info",
          confirmButtonText: "Tutup",
          showConfirmButton: true,
        });
      }
    },

    changePageSize(e) {
      var pageSize = "";

      if (e.target.value == "Semua Data") {
        pageSize = "500";
        this.pageSize = pageSize;
      } else {
        pageSize = e.target.value;
        this.pageSize = pageSize;
      }
      this.getData("0", pageSize, this.search);
    },

    cariData() {
      this.getData("0", this.pageSize, this.search);
    },

    pageChange() {
      alert(this.currentPage);
    },

    getData(currentPage, pageSize, filter) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });
      InformasiService.getInformasiUmum(currentPage, pageSize, filter)
        .then((response) => {
          loader.hide();
          this.items = response.data.data.content;
          this.pagination.totalPages = response.data.data.totalPages;
          this.currentPage = response.data.data.pageable.pageNumber + 1;
          setTimeout(() => loader.hide(), 1000);
        })
        .catch((error) => {
          // comment console console.log(error);
        });
    },

    uploadFile() {
      // document.getElementById('formUploadFile').click();
      // return false;
      $("#basic-addon2").click(function () {
        $("formUploadFile").click();
      });
    },

    deleteData(item, index) {
      this.formData = item;
      var vm = this;
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus data ini ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.value) {
            InformasiService.deleteInformasiUmum(this.formData)
              .then((response) => {
                vm.alertDeleteSuccess();
                this.getData("0", this.pageSize, "default");
              })
              .catch((error) => {
                this.alertError();
                vm.getData("0");

                // comment console console.log(error);
              });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            this.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },

    createData() {
      this.myModal = true;
      this.formData = {};
      this.formData.file = null;
      /**
       * #HANDLING#
       *
       * Handling Upload File Jika File Yang Di Upload Sama
       */
      this.$refs.uploadFileInformasiUmum.value = null;
      this.fileName = "";
      this.actionPost = "insert";
      this.title = "Tambah";
    },

    postData() {
      this.$v.$touch();
      if (this.actionPost == "insert") {
        if (this.$v.$invalid) {
          return;
        } else {
          this.insertData(this.formData);
        }
      } else if (this.actionPost == "update") {
        if (this.$v.$invalid) {
          return;
        } else {
          this.putData();
        }
      }
    },

    insertData(formData) {
      var vm = this;
      if (typeof formData.file === "string") {
        delete formData.file;
      }
      if (formData.file === null) {
        delete formData.file;
      }
      InformasiService.postInformasiUmum(formData).then(
        () => {
          vm.myModal = false;
          vm.alertSuccess();
          vm.clearValidation();
          // this.$store.dispatch("request/getInformasiUmum");
          vm.getData("0", "10", "default");
        },
        (error) => {
          // alert(error.response.data.message)
          // alert(error.message);
          // loader.hide();
          vm.$swal.fire({
            title: "Peringatan!",
            text: error.message,
            icon: "errorr",
            showCancelButton: true,
          });
        }
      );
    },

    putData() {
      // comment console console.log("put");
      // comment console console.log(this.formData);
      if (typeof this.formData.file === "string") {
        delete this.formData.file;
      }

      if (this.formData.file === null) {
        delete this.formData.file;
      }
      var vm = this;
      InformasiService.putInformasiUmum(this.formData)
        .then((response) => {
          vm.myModal = false;

          vm.alertEditSuccess();
          vm.clearValidation();

          vm.getData("0", "10", "default");
        })
        .catch((error) => {
          // comment console console.log(error);

          this.alertError();
        });
    },

    updateData(item, index) {
      this.myModal = true;
      this.formData = item;
      this.actionPost = "update";
      this.title = "Edit";
    },

    fileUpload(e) {
      this.formData.file = e.target.files[0];
      this.fileName = e.target.files[0].name;
      // comment console console.log(e.target.files);
    },

    closeModal() {
      this.myModal = false;
    },

    clearValidation() {
      this.$v.$reset();
      document.getElementById("judulInput").classList.remove("is-valid");
      document.getElementById("deskripsiInput").classList.remove("is-valid");
    },

    exportInformasiUmum() {
      InformasiService.exportInformasiUmum()
        .then((response) => {
          this.exportData(response.data, "InformasiUmum");
          this.alertExportSuccess();
          this.getData("0", "10", "default");
        })
        .catch((error) => {
          this.alertExportFailed();
          this.getData("0", "10", "default");
        });
    },
    roleData()
    {
      var user = JSON.parse(localStorage.getItem('user'));
      var data = user.singleData.detail_user.roles.find(el => el.url === this.$route.path );  
      this.role_status = data;
      console.log(this.role_status)
    }
  },
};
</script>